export function copyToClipboard(text, options = {}) {
    (async () => {
        try {
            await navigator.clipboard.writeText(text);
            options.onDone?.();
        }
        catch (error) {
            console.error('Failed to copy URL:', error);
        }
    })();
}
